@if (campusEvent === null) {
  <ion-progress-bar type="indeterminate">
  </ion-progress-bar>
}

@if (campusEvent) {
  <div class="overflow-scroll h-full">
    @if (campusEvent.event.businessName) {
      <h1 style="text-align: center;">
        {{ campusEvent.event.businessName }}
      </h1>
    }

    @if (campusEvent.event.image && campusEvent.event.image.length !== 0) {
      <swiper-container zoom="true" #swiper [thumbs]="{swiper: swiperDoc}">
        @for (image of campusEvent.event.image; track image.id) {
          <swiper-slide class="swiper-slide">
            <div class="swiper-zoom-container">
              <img [src]="image.url" class="main-image" />
            </div>
          </swiper-slide>
        }
      </swiper-container>
    } @else {
      <img
        style="margin-bottom: 5%;"
        alt="Silhouette of mountains"
        src="https://ionicframework.com/docs/img/demos/card-media.png"
      />
    }

    <ion-list lines="none">
      <ion-item>
        <ion-label>
          <h1 class="flex justify-center">
            {{ campusEvent.event.title | titlecase }} 
          </h1>
        </ion-label>
      </ion-item>
            
      <ion-item>
        <ion-label>
          @if (campusEvent.event.startTime && campusEvent.event.endTime) {
            <p class="sub-text">
              Times Available:
              {{ campusEvent.event.startTime | date : "hh:mm a" }} 
              to
              {{ campusEvent.event.endTime | date : "hh:mm a" }}
            </p>
          } @else if (!campusEvent.event.startTime && campusEvent.event.endTime) {
            <p class="sub-text">
              End Time:
              {{ campusEvent.event.endTime | date : "hh:mm a" }}
            </p>
          } @else if (campusEvent.event.startTime && !campusEvent.event.endTime) {
            <p class="sub-text">
              Start Time:
              {{ campusEvent.event.startTime | date : "hh:mm a" }}
            </p>
          }

          @if (campusEvent.event.daysAvailable && campusEvent.event.daysAvailable.length > 0) {
            <p class="sub-text">
              Event Days:
              {{ campusEvent.event.daysAvailable.join(", ") }}
            </p>
          } @else if (campusEvent.event.endDate) {
            <p class="sub-text">
              Event Date:
              {{ campusEvent.event.endDate | date : "M/d/yyyy" }}
            </p>
          }

          @if (campusEvent.event.street && campusEvent.event.city && campusEvent.event.state && campusEvent.event.zipCode) {
            <p
              class="sub-text"
            >
              Address:
              {{ campusEvent.event.street }}, {{ campusEvent.event.city }}, {{ campusEvent.event.state }} {{ campusEvent.event.zipCode }}
          </p>
          }

          <p class="description">
            {{ campusEvent.event.description }}
          </p>
        </ion-label>
      </ion-item>

      @if (campusEvent.event.url && campusEvent.event.url !== '') {
        <ion-item>
          <ion-label>
            <div class="flex justify-center">
              <ion-button (click)="visitEvent()"> Visit Site </ion-button>
            </div>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  </div>
}
